import { useCallback, useMemo } from 'react'
import { AppLang } from '../State/App/AppModel'
import { useTypedSelector } from '../State/RootReducer'

export const useLocalizeNumberValue = (): ((value: number) => string) => {
  const appLanguage = useTypedSelector(state => state.app.lang)
  const fallbackLanguage = navigator.language

  const languages: Record<
    AppLang,
    'de-DE' | 'en-US' | 'nl-NL' | 'fr-FR' | 'it-IT' | 'pl-PL' | 'pt-PT' | 'es-ES' | 'sv-SE' | 'el-GR' | 'gsw-FR' | 'gsw-CH'
  > = useMemo(
    () => ({
      de: 'de-DE',
      en: 'en-US',
      nl: 'nl-NL',
      fr: 'fr-FR',
      it: 'it-IT',
      pl: 'pl-PL',
      pt: 'pt-PT',
      es: 'es-ES',
      sv: 'sv-SE',
      el: 'el-GR',
      'gsw-FR': 'gsw-FR',
      'gsw-CH': 'gsw-CH',
    }),
    []
  )

  const language = appLanguage ? languages[appLanguage] : fallbackLanguage

  const localizeNumberValue = useCallback(
    (value: number) => {
      return Intl.NumberFormat(language, { maximumFractionDigits: 2 }).format(value)
    },
    [language]
  )

  return localizeNumberValue
}
